module.exports = __webpack_public_path__ + "sgby/img/diaochan-s.7799820.png";